/** @format */

import VariantHoverSwitchPlugin from "./plugin/variant-hover-switch.plugin";
import OffCanvasCartSwitchOptionPlugin from "./plugin/offcanvas-cart-switch-option.plugin";
import IwConfiguratorPlugin from "./plugin/iw-configurator.plugin";

const PluginManager = window.PluginManager;

if (window.interweberShowOnProductCard) {
    PluginManager.register(
        "VariantHoverSwitch",
        VariantHoverSwitchPlugin,
        "[data-variant-hover-switch]"
    );
}

if (window.interweberShowOnOffCanvasCart) {
    PluginManager.override(
        "OffCanvasCart",
        OffCanvasCartSwitchOptionPlugin,
        "[data-offcanvas-cart]"
    );
}

if (window.interweberShowOnProductDetail) {
    PluginManager.register(
        "IwConfigurator",
        IwConfiguratorPlugin,
        "[data-iw-configurator-component]"
    );
}
